import { useContext, useCallback } from 'react';

import { GlobalStateContext } from '../../../contexts/GlobalState';
import { globalStateActionType } from '../../../contexts/GlobalState/reducer';

import { msLoginPopup } from '../../../authProviders/microsoft';

import { DefaultButton } from '@fluentui/react/lib/Button';


export function MicrosoftSignInButton({
    setIsSigningIn, setSignInError
}) {
    const [, dispatch] = useContext(GlobalStateContext);

    const onLoginClick = useCallback(
        (_evt) => {
            setIsSigningIn(true);

            msLoginPopup()
                .then((cwTokens) => {
                    setSignInError(null);

                    dispatch({
                        type: globalStateActionType.SIGNIN,
                        value: {
                            ...cwTokens
                        }
                    });
                })
                .catch((err) => {
                    setSignInError(err);
                })
                .finally(() => {
                    setIsSigningIn(false);
                });
        },
        [dispatch, setIsSigningIn, setSignInError]
    );

    return (
        <DefaultButton
            text="Microsoft"
            onClick={onLoginClick}
        />
    );
}

